import { pageHead } from "@/lib/routeHead";
import { createFileRoute } from "@tanstack/react-router";
import StaffingAssignmentsPage from "@/pages/admin/StaffingAssignmentsPage";

export const Route = createFileRoute("/_admin/admin/staffing-assignments")({
  head: () => pageHead("Admin · Staffing Assignments", "AKIVA admin · staffing assignments portal.", "/admin/staffing-assignments", true),
  component: StaffingAssignmentsPage,
});
